<script setup lang="ts">
import { Sparkles } from '@lucide/vue';
import { cn } from '@/lib/utils';

const props = withDefaults(
    defineProps<{
        title: string;
        eyebrow?: string;
        description?: string;
        align?: 'left' | 'center';
        class?: string;
    }>(),
    {
        eyebrow: '',
        description: '',
        align: 'center',
        class: '',
    },
);
</script>

<template>
    <div
        :class="
            cn(
                'flex max-w-3xl flex-col gap-3',
                props.align === 'center'
                    ? 'mx-auto items-center text-center'
                    : 'items-start text-left',
                props.class,
            )
        "
    >
        <span
            v-if="props.eyebrow"
            class="border-primary/25 bg-primary/10 inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium"
        >
            <Sparkles class="text-primary size-3.5" aria-hidden="true" />
            {{ props.eyebrow }}
        </span>
        <h2
            class="font-display text-3xl leading-[1.15] text-balance sm:text-4xl"
        >
            {{ props.title }}
        </h2>
        <p
            v-if="props.description"
            class="text-muted-foreground max-w-2xl text-base leading-relaxed sm:text-lg"
        >
            {{ props.description }}
        </p>
    </div>
</template>
